<template>
    <div>
        <sg-items-block name="Не производить регистрацию по л/с, привязанным к моей карте">


            <template v-if="hasPhone">




                <template v-for="(card, i) in secureAllowedCard">




                    <v-list-item :key="card.pan" @click="toggleSetting(card)" style="min-height: 56px"
                        :disabled="!hasPhone">

                        <v-list-item-content class="d-block">
                            <v-list-item-title>
                                {{card.main ? 'Основная карта' : card.comment}}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                {{card.pan}}
                            </v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-action>
                            <sg-switch v-if="card.secureAllowed" :input-value="userInfo.settings.secureAccounts"
                                :value="card.pan" :loading="loadings[card.pan]" readonly :disabled="!hasPhone" />


                            <v-icon v-else>
                                mdi-lock
                            </v-icon>
                        </v-list-item-action>

                    </v-list-item>

                    <v-divider v-if="i < secureAllowedCard.length -1" style="margin-left: 16px" :key="'d-'+i" />

                </template>


            </template>
        </sg-items-block>

        <v-alert v-if="!hasPhone" class="text-body-2 my-2" type="info" text :icon="false">
            Чтобы воспользоваться данной функцией необходимо указать номер телефона

            <div class="d-flex justify-end mt-2">
                <v-btn color="primary" small outlined :to="{name: 'wv-settings-phone-edit'}">Указать</v-btn>
            </div>
        </v-alert>


    <!--  <sg-items-block name="Управление устройствами">

            <v-list-item @click="startEndOtherSessions" style="min-height: 56px">

                <v-list-item-content class="d-block">
                    <v-list-item-title>
                        Выйти со всех устройств
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        Кроме текущего
                    </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                    <v-icon>mdi-location-exit</v-icon>
                </v-list-item-action>
            </v-list-item>
           

        </sg-items-block>  -->

        <sg-nav-back-btn class="mt-3" />
    </div>
</template>

<script>
    /** ужещточить secureAllowed */

    import settingsMixin from './settingsMixin'

    export default {

        mixins: [settingsMixin],

        computed: {
            values() {
                if (!this.userInfo.settings.secureAccounts) return {}

                return this.userInfo.cards.reduce((map, card) => {

                    map[card.pan] = this.userInfo.settings.secureAccounts.includes(card.pan)
                    return map
                }, {})
            },

            secureAllowedCard() {
                return this.userInfo.cards //.filter(card => card.secureAllowed)
            }
        },

        created() {
            this.userInfo.cards.forEach(card => {
                this.$set(this.loadings, card.pan, false)
            })
        },

        data() {
            return {
                loadings: {},
            }
        },

        methods: {

    /*         startEndOtherSessions() {
                this.$eventBus.$emit('modal:dialog', {
                    props: {
                        message: 'Вы точно хотите завершить все сеансы на других устройствах?',
                        acceptText: 'Отмена',
                        rejectText: 'Завершить'
                    },
                    dialogProps: {
                        noClickAnimation: true,
                        persistent: true,
                    },
                    listeners: {
                        reject: () => {
                            this.endOtherSessions()
                        }
                    }
                })
            }, 


            endOtherSessions() {
                this.$eventBus.$emit('loader:show', {
                    overlay: true
                })
                this.$api.endOtherSessions()
                    .then(res => {
                        this.$eventBus.$emit('snackbar:open', {
                            message: "Сессии на всех устройствах кроме этого были успешно завершены"
                        })
                    })
                    .catch(error => {
                        this.$eventBus.$emit('error', error)
                    })
                    .finally(() => {
                        this.$eventBus.$emit('loader:hide')
                    })
            }, */

            createNewValue(pan) {



                let newValue = Object.entries(this.values).filter(entry => entry[1]).map(entry => entry[0])

                if (this.values[pan]) {

                    let indexToRemove = newValue.indexOf(pan)

                    if (indexToRemove > -1) {

                        newValue.splice(indexToRemove, 1)
                    }

                } else {


                    newValue.push(pan)
                }

                return newValue
            },

            toggleSetting(card) {

                if (!card || !card.secureAllowed) return


                let pan = card.pan

                if (this.loadings[pan]) return


                let newValue = this.createNewValue(pan)

                this.loadings[pan] = true

                this.changeSettings('secureAccounts', newValue)
                    .finally(() => {
                        this.loadings[pan] = false
                    })
            }


        }

    }
</script>

<style>

</style>